export default "__VITE_ASSET__DG51GBdO__"